module.exports = {"api":"https://rice-ipad.maeriminterfood.com/","api_pro":"https://rice-ipad.maeriminterfood.com/","printer_url":"moshihome.thddns.net:3331"}


//////////////////
// WEBPACK FOOTER
// ./static/apiurl.json
// module id = 1012
// module chunks = 31